/*!
 * Lightbox v2.10.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2018 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */

const Lightbox2 = (($) => {
  const Default = {
    albumLabel: "Image %1 of %2",
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
	    Sanitize Title
	    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
	    This will free you to add html tags, such as links, in the caption.
	    If the caption data is user submitted or from some other untrusted source, then set this to true
	    to prevent xss and other injection attacks.
	     */
    sanitizeTitle: false,
  };

  class Lightbox2 {
    constructor(options) {
      this.album = [];
      this.currentImageIndex = void 0;
      this.init();

      this.options = $.extend({}, Default);
      this.option(options);
    }

    option(options) {
      $.extend(this.options, options);
    }

    imageCountLabel(currentImageNum, totalImages) {
      return this.options.albumLabel
        .replace(/%1/g, currentImageNum)
        .replace(/%2/g, totalImages);
    }

    init() {
      const self = this;

      $(document).ready(function () {
        self.enable();
        self.build();
      });
    }

    enable() {
      const self = this;

      $("body").on(
        "click",
        "a[data-nhw-lightbox], area[data-nhw-lightbox]",
        function (event) {
          console.dir("clicked images");
          self.start($(event.currentTarget));
          return false;
        }
      );
    }

    build() {
      if ($("#nhw-lightbox").length > 0) {
        return;
      }

      const self = this;

      $(
        '<div id="nhw-lightboxOverlay" class="nhw-lightboxOverlay"></div><div id="nhw-lightbox" class="nhw-lightbox"><div class="nhw-lb-outerContainer"><div class="nhw-lb-container"><img class="nhw-lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="Picture" /><div class="nhw-lb-nav"><a class="nhw-lb-prev" href="" ><span class="sr-only">Previous</span></a><a class="nhw-lb-next" href="" ><span class="sr-only">Next</span></a></div><div class="nhw-lb-loader"><a class="nhw-lb-cancel"></a></div></div></div><div class="nhw-lb-dataContainer"><div class="nhw-lb-data"><div class="nhw-lb-details"><span class="nhw-lb-caption"></span><span class="nhw-lb-number"></span></div><div class="nhw-lb-closeContainer"><a class="nhw-lb-close"></a></div></div></div></div>'
      ).appendTo($("body"));

      // Cache jQuery objects
      this.$lightbox = $("#nhw-lightbox");
      this.$overlay = $("#nhw-lightboxOverlay");
      this.$outerContainer = this.$lightbox.find(".nhw-lb-outerContainer");
      this.$container = this.$lightbox.find(".nhw-lb-container");
      this.$image = this.$lightbox.find(".nhw-lb-image");
      this.$nav = this.$lightbox.find(".nhw-lb-nav");

      // Store css values for future lookup
      this.containerPadding = {
        top: parseInt(this.$container.css("padding-top"), 10),
        right: parseInt(this.$container.css("padding-right"), 10),
        bottom: parseInt(this.$container.css("padding-bottom"), 10),
        left: parseInt(this.$container.css("padding-left"), 10),
      };

      this.imageBorderWidth = {
        top: parseInt(this.$image.css("border-top-width"), 10),
        right: parseInt(this.$image.css("border-right-width"), 10),
        bottom: parseInt(this.$image.css("border-bottom-width"), 10),
        left: parseInt(this.$image.css("border-left-width"), 10),
      };

      // Attach event handlers to the newly minted DOM elements
      this.$overlay.hide().on("click", function () {
        self.end();
        return false;
      });

      this.$lightbox.hide().on("click", function (event) {
        if ($(event.target).attr("id") === "nhw-lightbox") {
          self.end();
        }
        return false;
      });

      this.$outerContainer.on("click", function (event) {
        if ($(event.target).attr("id") === "nhw-lightbox") {
          self.end();
        }
        return false;
      });

      this.$lightbox.find(".nhw-lb-prev").on("click", function () {
        if (self.currentImageIndex === 0) {
          self.changeImage(self.album.length - 1);
        } else {
          self.changeImage(self.currentImageIndex - 1);
        }
        return false;
      });

      this.$lightbox.find(".nhw-lb-next").on("click", function () {
        if (self.currentImageIndex === self.album.length - 1) {
          self.changeImage(0);
        } else {
          self.changeImage(self.currentImageIndex + 1);
        }
        return false;
      });

      /*
		      Show context menu for image on right-click
		      There is a div containing the navigation that spans the entire image and lives above of it. If
		      you right-click, you are right clicking this div and not the image. This prevents users from
		      saving the image or using other context menu actions with the image.
		      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
		      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
		      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
		      we set the pointer events back to auto for the nav div so it can capture hover and left-click
		      events as usual.
		     */
      this.$nav.on("mousedown", function (event) {
        if (event.which === 3) {
          self.$nav.css("pointer-events", "none");

          self.$lightbox.one("contextmenu", function () {
            setTimeout(
              function () {
                this.$nav.css("pointer-events", "auto");
              }.bind(self),
              0
            );
          });
        }
      });

      this.$lightbox
        .find(".nhw-lb-loader, .nhw-lb-close")
        .on("click", function () {
          self.end();
          return false;
        });
    }

    start($link) {
      const self = this;
      let $window = $(window);

      $window.on("resize", $.proxy(this.sizeOverlay, this));

      $("select, object, embed").css({
        visibility: "hidden",
      });

      this.sizeOverlay();

      this.album = [];
      var imageNumber = 0;

      function addToAlbum($link) {
        self.album.push({
          alt: $link.attr("data-alt"),
          link: $link.attr("href"),
          title: $link.attr("data-title") || $link.attr("title"),
        });
      }

      // Support both data-lightbox attribute and rel attribute implementations
      var dataLightboxValue = $link.attr("data-nhw-lightbox");
      var $links;

      if (dataLightboxValue) {
        $links = $(
          $link.prop("tagName") +
            '[data-nhw-lightbox="' +
            dataLightboxValue +
            '"]'
        );
        for (var i = 0; i < $links.length; i = ++i) {
          addToAlbum($($links[i]));
          if ($links[i] === $link[0]) {
            imageNumber = i;
          }
        }
      } else {
        if ($link.attr("rel") === "nhw-lightbox") {
          // If image is not part of a set
          addToAlbum($link);
        } else {
          // If image is part of a set
          $links = $(
            $link.prop("tagName") + '[rel="' + $link.attr("rel") + '"]'
          );
          for (var j = 0; j < $links.length; j = ++j) {
            addToAlbum($($links[j]));
            if ($links[j] === $link[0]) {
              imageNumber = j;
            }
          }
        }
      }

      // Position Lightbox
      var top = $window.scrollTop() + this.options.positionFromTop;
      var left = $window.scrollLeft();
      this.$lightbox
        .css({
          top: top + "px",
          left: left + "px",
        })
        .fadeIn(this.options.fadeDuration);

      // Disable scrolling of the page while open
      if (this.options.disableScrolling) {
        $("html").addClass("nhw-lb-disable-scrolling");
      }

      this.changeImage(imageNumber);
    }

    changeImage(imageNumber) {
      const self = this;

      this.disableKeyboardNav();
      var $image = this.$lightbox.find(".nhw-lb-image");

      this.$overlay.fadeIn(this.options.fadeDuration);

      $(".nhw-lb-loader").fadeIn("slow");
      this.$lightbox
        .find(
          ".nhw-lb-image, .nhw-lb-nav, .nhw-lb-prev, .nhw-lb-next, .nhw-lb-dataContainer, .nhw-lb-numbers, .nhw-lb-caption"
        )
        .hide();

      this.$outerContainer.addClass("animating");

      // When image to show is preloaded, we send the width and height to sizeContainer()
      var preloader = new Image();

      preloader.onload = function () {
        var $preloader;
        var imageHeight;
        var imageWidth;
        var maxImageHeight;
        var maxImageWidth;
        var windowHeight;
        var windowWidth;

        $image.attr({
          alt: self.album[imageNumber].alt,
          src: self.album[imageNumber].link,
        });

        $preloader = $(preloader);

        $image.width(preloader.width);
        $image.height(preloader.height);

        if (self.options.fitImagesInViewport) {
          // Fit image inside the viewport.
          // Take into account the border around the image and an additional 10px gutter on each side.

          windowWidth = $(window).width();
          windowHeight = $(window).height();
          maxImageWidth =
            windowWidth -
            self.containerPadding.left -
            self.containerPadding.right -
            self.imageBorderWidth.left -
            self.imageBorderWidth.right -
            20;
          maxImageHeight =
            windowHeight -
            self.containerPadding.top -
            self.containerPadding.bottom -
            self.imageBorderWidth.top -
            self.imageBorderWidth.bottom -
            120;

          // Check if image size is larger then maxWidth|maxHeight in settings
          if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
            maxImageWidth = self.options.maxWidth;
          }
          if (
            self.options.maxHeight &&
            self.options.maxHeight < maxImageWidth
          ) {
            maxImageHeight = self.options.maxHeight;
          }

          // Is the current image's width or height is greater than the maxImageWidth or maxImageHeight
          // option than we need to size down while maintaining the aspect ratio.
          if (
            preloader.width > maxImageWidth ||
            preloader.height > maxImageHeight
          ) {
            if (
              preloader.width / maxImageWidth >
              preloader.height / maxImageHeight
            ) {
              imageWidth = maxImageWidth;
              imageHeight = parseInt(
                preloader.height / (preloader.width / imageWidth),
                10
              );
              $image.width(imageWidth);
              $image.height(imageHeight);
            } else {
              imageHeight = maxImageHeight;
              imageWidth = parseInt(
                preloader.width / (preloader.height / imageHeight),
                10
              );
              $image.width(imageWidth);
              $image.height(imageHeight);
            }
          }
        }

        self.sizeContainer($image.width(), $image.height());
      };

      preloader.src = this.album[imageNumber].link;
      this.currentImageIndex = imageNumber;
    }

    // Stretch overlay to fit the viewport
    sizeOverlay() {
      this.$overlay.width($(document).width()).height($(document).height());
    }

    // Animate the size of the lightbox to fit the image we are showing
    sizeContainer(imageWidth, imageHeight) {
      const self = this;

      var oldWidth = this.$outerContainer.outerWidth();
      var oldHeight = this.$outerContainer.outerHeight();
      var newWidth =
        imageWidth +
        this.containerPadding.left +
        this.containerPadding.right +
        this.imageBorderWidth.left +
        this.imageBorderWidth.right;
      var newHeight =
        imageHeight +
        this.containerPadding.top +
        this.containerPadding.bottom +
        this.imageBorderWidth.top +
        this.imageBorderWidth.bottom;

      function postResize() {
        self.$lightbox.find(".nhw-lb-dataContainer").width(newWidth);
        self.$lightbox.find(".nhw-lb-prevLink").height(newHeight);
        self.$lightbox.find(".nhw-lb-nextLink").height(newHeight);
        self.showImage();
      }

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.$outerContainer.animate(
          {
            width: newWidth,
            height: newHeight,
          },
          this.options.resizeDuration,
          "swing",
          function () {
            postResize();
          }
        );
      } else {
        postResize();
      }
    }

    // Display the image and its details and begin preload neighboring images.
    showImage() {
      this.$lightbox.find(".nhw-lb-loader").stop(true).hide();
      this.$lightbox
        .find(".nhw-lb-image")
        .fadeIn(this.options.imageFadeDuration);

      this.updateNav();
      this.updateDetails();
      this.preloadNeighboringImages();
      this.enableKeyboardNav();
    }

    // Display previous and next navigation if appropriate.
    updateNav() {
      // Check to see if the browser supports touch events. If so, we take the conservative approach
      // and assume that mouse hover events are not supported and always show prev/next navigation
      // arrows in image sets.
      var alwaysShowNav = false;
      try {
        document.createEvent("TouchEvent");
        alwaysShowNav = this.options.alwaysShowNavOnTouchDevices ? true : false;
      } catch (e) {}

      this.$lightbox.find(".nhw-lb-nav").show();

      if (this.album.length > 1) {
        if (this.options.wrapAround) {
          if (alwaysShowNav) {
            this.$lightbox
              .find(".nhw-lb-prev, .nhw-lb-next")
              .css("opacity", "1");
          }
          this.$lightbox.find(".nhw-lb-prev, .nhw-lb-next").show();
        } else {
          if (this.currentImageIndex > 0) {
            this.$lightbox.find(".nhw-lb-prev").show();
            if (alwaysShowNav) {
              this.$lightbox.find(".nhw-lb-prev").css("opacity", "1");
            }
          }
          if (this.currentImageIndex < this.album.length - 1) {
            this.$lightbox.find(".nhw-lb-next").show();
            if (alwaysShowNav) {
              this.$lightbox.find(".nhw-lb-next").css("opacity", "1");
            }
          }
        }
      }
    }

    // Display caption, image number, and closing button.
    updateDetails() {
      const self = this;

      // Enable anchor clicks in the injected caption html.
      // Thanks Nate Wright for the fix. @https://github.com/NateWr
      if (
        typeof this.album[this.currentImageIndex].title !== "undefined" &&
        this.album[this.currentImageIndex].title !== ""
      ) {
        var $caption = this.$lightbox.find(".nhw-lb-caption");
        if (this.options.sanitizeTitle) {
          $caption.text(this.album[this.currentImageIndex].title);
        } else {
          $caption.html(this.album[this.currentImageIndex].title);
        }
        $caption
          .fadeIn("fast")
          .find("a")
          .on("click", function (event) {
            if ($(this).attr("target") !== undefined) {
              window.open($(this).attr("href"), $(this).attr("target"));
            } else {
              location.href = $(this).attr("href");
            }
          });
      }

      if (this.album.length > 1 && this.options.showImageNumberLabel) {
        var labelText = this.imageCountLabel(
          this.currentImageIndex + 1,
          this.album.length
        );
        this.$lightbox.find(".nhw-lb-number").text(labelText).fadeIn("fast");
      } else {
        this.$lightbox.find(".nhw-lb-number").hide();
      }

      this.$outerContainer.removeClass("animating");

      this.$lightbox
        .find(".nhw-lb-dataContainer")
        .fadeIn(this.options.resizeDuration, function () {
          return self.sizeOverlay();
        });
    }

    // Preload previous and next images in set.
    preloadNeighboringImages() {
      if (this.album.length > this.currentImageIndex + 1) {
        var preloadNext = new Image();
        preloadNext.src = this.album[this.currentImageIndex + 1].link;
      }
      if (this.currentImageIndex > 0) {
        var preloadPrev = new Image();
        preloadPrev.src = this.album[this.currentImageIndex - 1].link;
      }
    }

    enableKeyboardNav() {
      $(document).on("keyup.keyboard", $.proxy(this.keyboardAction, this));
    }

    disableKeyboardNav() {
      $(document).off(".keyboard");
    }

    keyboardAction(event) {
      var KEYCODE_ESC = 27;
      var KEYCODE_LEFTARROW = 37;
      var KEYCODE_RIGHTARROW = 39;

      var keycode = event.keyCode;
      var key = String.fromCharCode(keycode).toLowerCase();
      if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
        this.end();
      } else if (key === "p" || keycode === KEYCODE_LEFTARROW) {
        if (this.currentImageIndex !== 0) {
          this.changeImage(this.currentImageIndex - 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(this.album.length - 1);
        }
      } else if (key === "n" || keycode === KEYCODE_RIGHTARROW) {
        if (this.currentImageIndex !== this.album.length - 1) {
          this.changeImage(this.currentImageIndex + 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(0);
        }
      }
    }

    // Closing time. :-(
    end() {
      this.disableKeyboardNav();
      $(window).off("resize", this.sizeOverlay);
      this.$lightbox.fadeOut(this.options.fadeDuration);
      this.$overlay.fadeOut(this.options.fadeDuration);
      $("select, object, embed").css({
        visibility: "visible",
      });
      if (this.options.disableScrolling) {
        $("html").removeClass("nhw-lb-disable-scrolling");
      }
    }
  }

  return new Lightbox2({});
})($);

export default Lightbox2;
